<div class="card">
  <form [formGroup]="form">
    <span *ngIf="initQuestionId()"></span>
    <mat-tab-group [class.header-less-tabs]="submitted" mat-stretch-tabs [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChanged($event);" [disableRipple]="true" preserveContent="true">
      <div *ngFor="let pagination of paginations; let pi = index;">
        <mat-tab #tab [disabled]='isLoading || (!submitted && pi > latestIndex)'>
           <div *ngIf="pi+1 > paginations.length-1 && isLoading">
              <object id="loading" [data]="loaderData" class="loader" scrolling="no" allowfullscreen="yes"></object>
           </div>
           <div class="results" *ngIf="pi+1 > paginations.length-1 && !isLoading && !notLastPage">
              <results [uuid]="uuid" style="border: none"></results>
           </div>
           <ng-template mat-tab-label>
             <div>
               <div><div class="mat-tab-label-inner"><span [innerHTML]="pillars_top[pi]"></span><br><span [innerHTML]="pillars_bottom[pi]"></span></div></div>
               <div *ngIf="pi+1 == 1" class="ink-bar-head">
                 <span *ngIf="!(!submitted && pi > latestIndex)" class="ink-bar-text-head">{{pi+1}}</span>
                 <span *ngIf="!submitted && pi > latestIndex" class="ink-bar-text-disabled-head">{{pi+1}}</span>
               </div>
               <div *ngIf="pi+1 > paginations.length - 1" class="ink-bar-tail">
                 <span *ngIf="!(!submitted && pi > latestIndex)" class="ink-bar-text-tail">{{pi+1}}</span>
                 <span *ngIf="!submitted && pi > latestIndex" class="ink-bar-text-disabled-tail">{{pi+1}}</span>
               </div>
               <div *ngIf="pi+1 > 1 && pi+1 <= paginations.length - 1" class="ink-bar">
                 <span *ngIf="!(!submitted && pi > latestIndex)" class="ink-bar-text">{{pi+1}}</span>
                 <span *ngIf="!submitted && pi > latestIndex" class="ink-bar-text-disabled">{{pi+1}}</span>
               </div>
             </div>
           </ng-template>
           <div *ngIf="!isLoading && pi+1 <= paginations.length-1" class="row">
             <div class="column1">
               <div class="pillar-label">
                 <span [innerHTML]="pillars_top_text[pi]"></span>&nbsp;<span [innerHTML]="pillars_bottom_text[pi]"></span>
               </div>
               <br/><br/>
               <img src="assets/images/pillar{{pi}}.jpg" class="pageImage">
             </div>
             <div class="column2">
               <div *ngFor="let question of questions.slice(paginations[pi]-1, paginations[pi+1]-1); let i = index">
                 <app-question *ngIf="!submitted && showQuestion(question, questions, form.controls)" [isNumbered]="isNumbered(question.key)" [isSubnumbered]="isSubnumbered(question.key)" [qId]="questionCounter" [question]="question" [form]="form" [qNo]="i" style="border: none" class="card" [required]="question.required" [optionCount]="question.options.length" [validity]="form.controls[question.key].valid" [submitted]="submitted" [placeholder]="getPlaceholder(question)" [hint]="getHint(question)" [markers]="getMarkers(question.key)"></app-question>
                 <span *ngIf="!submitted && incQuestionId(questions, form.controls, question.key)"></span>
               </div>
             </div>
           </div>
           <br/>
           <div *ngIf="false && pi+1 <= paginations.length-1">
              <span *ngIf="!isLoading && !submitted" class="completed-label">Completed&nbsp;</span>
              <span *ngIf="!isLoading && !submitted" class="completed-count">{{countCompleted(questions, form.controls)}}&nbsp;</span>
           </div>
           <div class="form-group pad-left pad-right" *ngIf="!isLoading">
              <div class="row">
                <div class="column1">
                </div>
                <div class="column2">
                  <div *ngIf="disclaimerText.length && pi+1 == paginations.length-1" class="pad-left-disclaimer pad-bottom">
                     <div class="disclaimer-text">{{disclaimerText}}</div>
                  </div>
                  <div *ngIf="pi+1 == paginations.length-1">
                    <div class="required-text">
                       <span style="color: red">*</span>
                       These fields are required
                    </div>
                    <div class="alert alert-danger text-label" *ngIf="errMsg !== ''" style="margin-left: 30px;">
                      {{errMsg}}
                      <br><br>
                    </div>                    
                    <div class="button-row">
                      <div class="button-column">
                        <button *ngIf="pi+1 > 1" (click)="previousStep(pi)" class="btn btn-block btn-danger previous-button">Previous</button>
                      </div>
                      <div class="button-column">
                        <button (click)="submit()" [disabled]="submitted || !pageCompleted(questions, 0, questions.length, form.controls)" class="btn btn-block btn-danger next-button">Submit</button>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="pi+1 < paginations.length-1">
                    <div class="required-text">
                       <span style="color: red">*</span>
                       These fields are required
                    </div>
                    <div class="button-row">
                      <div class="button-column">
                        <button *ngIf="pi+1 > 1" (click)="previousStep(pi)" class="btn btn-block btn-danger previous-button">Previous</button>
                      </div>
                      <div class="button-column">
                        <button *ngIf="pi+1 < paginations.length-1" (click)="nextStep(pi)" [disabled]="!pageCompleted(questions, paginations[pi]-1, paginations[pi+1]-1, form.controls)" class="btn btn-block btn-danger next-button">Next</button>
                      </div>
                      <div class="button-column">
                        <button *ngIf="pi+1 > paginations.length-1" (click)="restart()" [disabled]="!submitted" class="btn btn-block btn-danger custom-button">Restart (testers)</button>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="pi+1 >= paginations.length-1">
                    <div class="button-column">
                      <button *ngIf="pi+1 > paginations.length-1" (click)="restart()" [disabled]="!submitted" class="btn btn-block btn-danger restart-button">Restart</button>
                    </div>
                    <div class="button-column">
                    </div>
                  </div>
                </div>
              </div>
           </div>
        </mat-tab>
      </div>
    </mat-tab-group>
  </form>
</div>
